import { render, staticRenderFns } from "./MRI.vue?vue&type=template&id=237d3774&scoped=true"
import script from "./MRI.vue?vue&type=script&lang=js"
export * from "./MRI.vue?vue&type=script&lang=js"
import style0 from "./MRI.vue?vue&type=style&index=0&id=237d3774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d3774",
  null
  
)

export default component.exports